@if (links$ | async; as links) {
    @for (link of links; track link) {
        <ms-list-item
            msTrackReferringActionDirective
            [trackingValue]="trackingValue()"
            [cleanAfterTrack]="cleanedAfterTrack()"
            [title]="link.linkText"
            [icon]="link.icon"
            [href]="link.link"
            [iconSize]="16"
            [isShowBorder]="!$last"
            (itemClicked)="onLinkClick(link)"></ms-list-item>
    }
}
